import { useState } from 'react';
import { TabPanel, a11yProps } from '../../UI/MuiTab';

import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import GridProvider from './components/GridProvider';

const ORDER_DUMMYDATA = [
  {
    orderNumber: '20-TC633-145454',
    machineType: 'NHX43200806 NHX4000Ge3 Davis',
    technology: 'Machine',
    reportedBy: '-',
    notificationDate: '10/14/2020, 15:32',
    subRows: [
      {
        status: 'In progress',
        orderType: 'Phone - Inquiry/Problem',
        billingType: '-',
        title: 'Install machine in our showroom',
        notificationDate: '10/14/2020, 15:32',
      },
      {
        status: 'In progress',
        orderType: 'Phone - Inquiry/Problem',
        billingType: '-',
        title: 'Install machine in our showroom',
        notificationDate: '10/14/2020, 15:32',
      },
      {
        status: 'In progress',
        orderType: 'Phone - Inquiry/Problem',
        billingType: '-',
        title: 'Install machine in our showroom',
        notificationDate: '10/14/2020, 15:32',
      },
      {
        status: 'In progress',
        orderType: 'Phone - Inquiry/Problem',
        billingType: '-',
        title: 'Install machine in our showroom',
        notificationDate: '10/14/2020, 15:32',
      },
      {
        status: 'Open',
        orderType: 'Field Service',
        billingType: 'Non-Billable',
        title: 'Set up the machine',
        notificationDate: '10/14/2020, 15:32',
      },
    ],
  },
  {
    orderNumber: '21-RX847-332211',
    machineType: 'AXZ100304 VT5000E Houston',
    technology: 'Advanced Tech',
    reportedBy: 'John Doe',
    notificationDate: '11/20/2020, 12:45',
    subRows: [
      {
        status: 'Completed',
        orderType: 'Online Support',
        billingType: 'Billable',
        title: 'Software update installation',
        notificationDate: '11/20/2020, 12:45',
      },
      {
        status: 'Pending',
        orderType: 'Maintenance',
        billingType: 'Non-Billable',
        title: 'Routine machine checkup',
        notificationDate: '11/20/2020, 12:45',
      },
    ],
  },
  {
    orderNumber: '22-BV559-789012',
    machineType: 'BNM43201123 ZX9000E Smith',
    technology: 'Robotics',
    reportedBy: 'Alice Johnson',
    notificationDate: '02/15/2021, 09:30',
    subRows: [
      {
        status: 'Delayed',
        orderType: 'Repair',
        billingType: 'Billable',
        title: 'Replace robotic arm',
        notificationDate: '02/15/2021, 09:30',
      },
      {
        status: 'In review',
        orderType: 'Inspection',
        billingType: '-',
        title: 'Annual safety review',
        notificationDate: '02/15/2021, 09:30',
      },
    ],
  },
];
const PregledPorudzbina = () => {
  const { t, i18n } = useTranslation();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      <Box sx={{ width: '98%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            style={{ padding: '2px' }}
          >
            <Tab
              label={t('all')}
              sx={{ textTransform: 'none' }}
              {...a11yProps(0)}
            />
            <Tab
              label="Open"
              {...a11yProps(1)}
              sx={{ textTransform: 'none' }}
            />

            <Tab
              sx={{ textTransform: 'none' }}
              label="In progress"
              {...a11yProps(2)}
            />
            <Tab
              sx={{ textTransform: 'none' }}
              label="Closed"
              {...a11yProps(3)}
            />
            <Tab
              sx={{ textTransform: 'none' }}
              label="Canceled"
              {...a11yProps(4)}
            />
          </Tabs>
        </Box>
      </Box>
      <TabPanel value={value} index={0}>
        <GridProvider data={ORDER_DUMMYDATA} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <GridProvider data={ORDER_DUMMYDATA} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <GridProvider data={ORDER_DUMMYDATA} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <GridProvider data={ORDER_DUMMYDATA} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <GridProvider data={ORDER_DUMMYDATA} />
      </TabPanel>
    </div>
  );
};

export default PregledPorudzbina;
